import React from "react";
import { Textfield } from "cxa-components";
import FormField from "./FormField";

const StringField = props => (
  <FormField component={Textfield} boxed {...props} />
);

export default StringField;



// WEBPACK FOOTER //
// ./components/common/form-field/StringField.js